import { useContext } from 'react';

import { IconSetContext } from 'components/icons/IconSetContext';
import { resolveIcon } from 'helpers/iconRegistry';
import { IconComponent, IconSet, IconSlug } from 'types/icons';

export const useLibraryIcon = (slug: IconSlug): { Svg: IconComponent; set: IconSet } | null => {
  const context = useContext(IconSetContext);

  return context ? resolveIcon(context.icons, context.set, slug) : null;
};
